import { FC } from 'react';
import style from './index.module.css';

export const HorizontalRule: FC<{ 
  size?: 'large' | 'medium' | 'small',
  transparent?: boolean
}> = ({ size = 'medium', transparent = false }) => {

  let className = style.horizontalRule;

  if (size === 'large') className = `${className} ${style.large}`;
  if (size === 'small') className = `${className} ${style.small}`;

  return (
    <hr className={className} data-spacer={transparent}/>
  )
}